import React, { useEffect } from "react";
import "@/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Differentiators from "./components/Differentiators";
import SeoLocations from "./components/SeoLocations";
import Faq from "./components/Faq";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    document.title =
      "PJ Caçambas de Entulho em Jundiaí | Aluguel de Caçambas e Disk Entulho";
  }, []);

  return (
    <div className="App font-body bg-white text-[#0f172a]">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Differentiators />
        <SeoLocations />
        <Faq />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
